export const VIDEO_ID = 'OlJeS_8jcc0';
export const SOUNDTRACK_DURATION_MS = 210000;
export const SHOW_START_DELAY_MS = 6000;
export const INTRO_REVEAL_GAP_MS = 750;
export const FIRST_REVEAL_DELAY_MS = SHOW_START_DELAY_MS + INTRO_REVEAL_GAP_MS;
export const SHOW_END_BUFFER_MS = 3000;
export const MIN_PHOTO_REVEAL_MS = 240;
export const SOUNDTRACK_RETRY_MS = 250;
export const SOUNDTRACK_MAX_ATTEMPTS = 12;
export const REVIEW_WHEEL_STEP_DELTA = 420;
export const REVIEW_WHEEL_MAX_STEPS = 4;
export const REVIEW_WHEEL_COOLDOWN_MS = 180;
export const INTRO_LINES = 3;
export const INTRO_VARIANTS = [
    (yearLabel: string, speciesCount: string) => [
        `In ${yearLabel}, you answered the call of the outdoors.`,
        `You discovered ${speciesCount} species along the way.`,
        "Let's relive every unforgettable moment."
    ],
    (_yearLabel: string, speciesCount: string) => [
        'One year.',
        `${speciesCount} species.`,
        'Countless memories. Ready to revisit them?'
    ],
    (yearLabel: string) => [
        'Some birds were expected.',
        'Others became lifelong memories.',
        `This was ${yearLabel}.`
    ],
    (_yearLabel: string, speciesCount: string) => [
        'You explored.',
        `You discovered ${speciesCount} species.`,
        'Now enjoy the highlights.'
    ],
    (yearLabel: string, speciesCount: string) => [
        'Through forests, fields, and shorelines...',
        `...you discovered ${speciesCount} remarkable species.`,
        `Welcome back to ${yearLabel}.`
    ]
] as const;
